// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fund-criteria-select-options {
  display: flex;
  flex-direction: column;
}

.fund-criteria-select-group {
  display: flex;
  flex-direction: column;
}

.fund-criteria-select-group-label {
  box-sizing: border-box;
  width: 100%;
  padding: 12px 16px;
  background-color: var(--surface-senary);
  color: var(--text-primary);
  text-align: left;
}

.fund-criteria-select-option-item {
  box-sizing: border-box;
  width: 100%;
  padding: 12px 16px;
  cursor: pointer;
  &:hover {
    background-color: var(--color-brand-hover2);
  }
}

.fund-criteria-select-option-item.disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.fund-criteria-select-count {
  box-sizing: border-box;
  width: 100%;
  padding: 8px 16px;
  color: var(--text-label);
  text-align: left;
}

.fund-criteria-select-option-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: 100%;
}

.fund-criteria-select-option-toggle-checkbox {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.fund-criteria-select-option-toggle-checkbox svg {
  width: 24px;
  height: 24px;
}

/* Checked checkbox's background fill is hardcoded orange in the SVG —
   override with the theme's brand color. Scoped to \`.checked\` only — the
   unchecked icon's single path is also \`:first-of-type\`, so an unscoped
   selector would recolor its border too. */
.fund-criteria-select-option-toggle-checkbox.checked svg path:first-of-type {
  fill: var(--color-brand);
}

/* ToggleButton renders this label as a plain \`\${className}-label\` div, so it
   can't take a typography class via props — values match body-m-regular by hand. */
.fund-criteria-select-option-toggle-label {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-primary);
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/Components/FundScreener/Criteria/FundCriteriaSelect/FundCriteriaSelect.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,uCAAuC;EACvC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;2CAG2C;AAC3C;EACE,wBAAwB;AAC1B;;AAEA;mFACmF;AACnF;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;AAClB","sourcesContent":[".fund-criteria-select-options {\n  display: flex;\n  flex-direction: column;\n}\n\n.fund-criteria-select-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.fund-criteria-select-group-label {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 12px 16px;\n  background-color: var(--surface-senary);\n  color: var(--text-primary);\n  text-align: left;\n}\n\n.fund-criteria-select-option-item {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 12px 16px;\n  cursor: pointer;\n  &:hover {\n    background-color: var(--color-brand-hover2);\n  }\n}\n\n.fund-criteria-select-option-item.disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.fund-criteria-select-count {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 8px 16px;\n  color: var(--text-label);\n  text-align: left;\n}\n\n.fund-criteria-select-option-toggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  height: 100%;\n}\n\n.fund-criteria-select-option-toggle-checkbox {\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.fund-criteria-select-option-toggle-checkbox svg {\n  width: 24px;\n  height: 24px;\n}\n\n/* Checked checkbox's background fill is hardcoded orange in the SVG —\n   override with the theme's brand color. Scoped to `.checked` only — the\n   unchecked icon's single path is also `:first-of-type`, so an unscoped\n   selector would recolor its border too. */\n.fund-criteria-select-option-toggle-checkbox.checked svg path:first-of-type {\n  fill: var(--color-brand);\n}\n\n/* ToggleButton renders this label as a plain `${className}-label` div, so it\n   can't take a typography class via props — values match body-m-regular by hand. */\n.fund-criteria-select-option-toggle-label {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-primary);\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
